import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactTextField from '../../../common/components/UI/TextField/TextField';
import { ManagerCreateRequestsActionNames } from '../../Enums';

/**
 * @typedef {{ aggregateRootId: string, name: string }} IManagerSetting
 * @param {{
 *  classes: *,
 *  name: string,
 *  description: string,
 *  details: string,
 *  handleChangeTextfield: (target: string, value: string) => void,
 *  setErrors: (value: boolean) => void,
 *  managerList: IManagerSetting[],
 *  action: string,
 *  settingSelected: IManagerSetting,
 * }} param0
 */
const SettingInformationStep = ({ classes, name, description, details, handleChangeTextfield, setErrors, managerList, action, settingSelected }) => {
    const { t } = useTranslation('employmentBillboard');
    const usedManagerSettingNames = managerList.filter(x => {
        if (action === ManagerCreateRequestsActionNames.Duplicate && settingSelected.aggregateRootId === x.aggregateRootId) {
            // It is the original manager setting that is getting duplicated, add to list of used names
            return true;
        }
        return x.aggregateRootId !== settingSelected.aggregateRootId;
    }).map(x => x.name);
    /**
     * 
     * @param {string} name 
     * @returns {boolean}
     */
    const isUsed = (name) => !!usedManagerSettingNames.includes(name);

    useEffect(() => {
        setErrors(isUsed(name));
    }, [name])
    return (
        <>
            <ReactTextField
                classes={classes}
                outlinedLabel
                label={t('settings.name')}
                error={isUsed(name)}
                value={name}
                valueString={'name'}
                changeHandler={handleChangeTextfield}
                inputLength={50}
                placeholder={t('form.namePlaceholder')}
            />
            <p>
                <small className={classes.maxLength}>{t('form.descName')}</small>
            </p>
            <ReactTextField
                classes={classes}
                outlinedLabel
                label={t('settings.description_long')}
                value={description}
                valueString={'description'}
                rows={4}
                changeHandler={handleChangeTextfield}
                inputLength={250}
                placeholder={t('form.descriptionPlaceholder')}
            />
            <p>
                <small className={classes.maxLength}>{t('form.descMaxChar')}</small>
            </p>
            <ReactTextField
                classes={classes}
                outlinedLabel
                label={t('settings.details')}
                value={details}
                valueString={'details'}
                multiline={true}
                rows={4}
                changeHandler={handleChangeTextfield}
                inputLength={250}
                placeholder={t('form.detailsPlaceholder')}
            />
            <p>
                <small className={classes.maxLength}>{t('form.descMaxChar')}</small>
            </p>
        </>);
}

export default SettingInformationStep;